export default __webpack_public_path__ + "static/media/typescript.bca3f91c.png";